import { render } from "./UserReg.vue?vue&type=template&id=711cc0f8&scoped=true"
import script from "./UserReg.vue?vue&type=script&lang=js"
export * from "./UserReg.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-711cc0f8"

export default script